import { CommonModule } from '@angular/common';
import {Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import {PaginationClass, PaginationModel} from "../../../../common/pagination";
import {LoaderComponent} from "../../../common/loader/loader.component";
import {ApiService, CustomHttpParams} from "../../../../services/api.service";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

interface EventPollHistory {
  dttm: string;
  status: string;
  job_id?: string;
  timeout?: string;
}

@Component({
  selector: 'app-event-poll-history',
  standalone: true,
  imports: [RouterModule, CommonModule, NgxPaginationModule, LoaderComponent],
  templateUrl: './event-poll-history.component.html',
  styleUrl: './event-poll-history.component.scss'
})
export class EventPollHistoryComponent implements OnInit, OnDestroy {
  public isLoading: boolean = false;

  public ven_id: string = '';
  protected readonly paginationId = 'paginationEventPoll';
  private pagination = new PaginationClass(this.paginationId);
  protected paginationModel: PaginationModel = this.pagination.getPaginationModel();

  public displayedEventPollHistories: EventPollHistory[] = [];
  public pollHistories: EventPollHistory[] = [];
  protected unsubscribe = new Subject<void>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.ven_id = params['id'];
      this.paginationModel = this.pagination.resetPagination();
      this.loadEventPollHistory();
    });
  }

  loadEventPollHistory(): void {
    this.isLoading = true;
    const queryParams: CustomHttpParams = {
      'depth': 1,
      'limit': this.pagination.itemsPerPage,
      'offset': this.pagination.offset,
      'ven_id': this.ven_id
    };
    this.apiService.getEventPollHistory(queryParams)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response: any[]) => {
          this.pollHistories = response.map(pollHistory => {
            // Parse the timestamp from the job_id as in the original implementation
            const dttm_int = parseInt(pollHistory.job_id.split(";")[1]);
            return {
              ...pollHistory,
              dttm: new Date(dttm_int * 1000).toISOString()
            };
          });
          this.paginationModel = this.pagination.updateTotalItems(response.length);
          this.displayedEventPollHistories = this.pollHistories;
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error loading event poll history:', err);
          this.isLoading = false;
        }
      });
  }

  handlePageChange(newPage: number) {
    this.paginationModel = this.pagination.changePage(newPage);
    this.loadEventPollHistory();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
